import { render } from "./payment-callback.view.vue?vue&type=template&id=7dd8675f"
import script from "./payment-callback.view.vue?vue&type=script&lang=js"
export * from "./payment-callback.view.vue?vue&type=script&lang=js"

import "./payment-callback.view.vue?vue&type=style&index=0&id=7dd8675f&lang=css"

import exportComponent from "/mnt/ssd2/projects/techno2_remaster/client_ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__